import { scoreItems, stats, verdictCons, verdictPros } from "../../../mocks/guaData";

function ScoreBar({ label, score }: { label: string; score: number }) {
  return (
    <div className="flex items-center gap-3">
      <span className="w-24 whitespace-nowrap text-sm text-foreground-700">{label}</span>
      <div className="h-2 flex-1 overflow-hidden rounded-full bg-background-100">
        <div
          className="h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-600"
          style={{ width: `${score * 10}%` }}
        ></div>
      </div>
      <span className="w-10 text-right text-sm font-semibold text-primary-700">{score}</span>
    </div>
  );
}

export default function Verdict() {
  return (
    <section id="verdict" className="w-full bg-background-50 py-14 md:py-20" aria-label="实测结论">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-sm font-semibold uppercase tracking-wider text-accent-600">Verdict</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            吃瓜神器到底怎么样？真实体验结论
          </h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            用了整整两周，我们从资讯丰富度、更新时效、易用程度和界面观感四个维度给出主观评分，
            再把它值得夸的地方与稍显遗憾的地方都摊开讲清楚。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div className="flex flex-col justify-between rounded-lg bg-primary-500 p-6 text-white lg:col-span-1">
            <div>
              <p className="text-sm opacity-90">综合推荐指数</p>
              <p className="mt-2 font-heading text-6xl font-bold">8.9</p>
              <p className="mt-2 text-sm text-white/85">值得推荐 · 爱吃瓜的冲就完事</p>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3">
              {stats.map((s) => (
                <div key={s.label} className="rounded-md bg-white/15 p-3 backdrop-blur-sm">
                  <p className="font-heading text-xl font-bold">{s.value}</p>
                  <p className="text-xs text-white/85">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg bg-background-100 p-6 ring-1 ring-background-200 lg:col-span-2">
            <h3 className="font-heading text-base font-semibold text-foreground-950">四维体验评分</h3>
            <div className="mt-5 flex flex-col gap-4">
              {scoreItems.map((s) => (
                <ScoreBar key={s.label} label={s.label} score={s.score} />
              ))}
            </div>
            <p className="mt-5 rounded-md bg-background-50 p-3 text-sm leading-relaxed text-foreground-600 ring-1 ring-background-200">
              <i className="ri-information-line mr-1 text-accent-600" aria-hidden="true"></i>
              评分基于吃瓜研究所两周真实使用与同类工具对比得出，带有一定主观性，仅供参考。
            </p>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2">
          <div className="rounded-lg bg-background-50 p-6 ring-1 ring-background-200">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-white">
                <i className="ri-thumb-up-line text-sm" aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-950">值得夸的地方</h3>
            </div>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {verdictPros.map((p) => (
                <div key={p.title} className="rounded-md bg-background-100 p-4">
                  <i className={`text-lg text-primary-600 ${p.icon}`} aria-hidden="true"></i>
                  <h4 className="mt-2 text-sm font-semibold text-foreground-950">{p.title}</h4>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg bg-background-100 p-6 ring-1 ring-background-200">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-500 text-white">
                <i className="ri-thumb-down-line text-sm" aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-950">稍显遗憾的地方</h3>
            </div>
            <div className="mt-5 flex flex-col gap-4">
              {verdictCons.map((c) => (
                <div key={c.title} className="rounded-md bg-background-50 p-4 ring-1 ring-background-200">
                  <div className="flex items-center gap-2">
                    <i className={`text-base text-secondary-600 ${c.icon}`} aria-hidden="true"></i>
                    <h4 className="text-sm font-semibold text-foreground-950">{c.title}</h4>
                  </div>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">{c.desc}</p>
                </div>
              ))}
            </div>
            <p className="mt-4 rounded-md bg-accent-100 p-3 text-sm font-medium text-accent-800">
              结论：只要你不是重度历史考据党，吃瓜神器完全够用，值得推荐。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}